import { getToken } from '../api';
import { useAppSelector } from './use-app-selector';

export const useUserIsAuthorized = () => {
	const { user } = useAppSelector((state) => state.user);
	const token = getToken();
	!!token && window.getAuthToken?.(token);
	return { userIsAuthorized: user !== null && !!token, user };
};
